// extracted by mini-css-extract-plugin
export default {"noUnderline":"Table_noUnderline__Ablji"};